export function removeEspecialCharacters(value) {
  return value.replace(/[^\d]+/g,'');
}